import React from 'react';
import { NamedLink, ExternalLink, LinkedLogo } from '../../components';
import { instagramIconV2 } from '../../containers/PageBuilder/Primitives/Link/Icons';
import { useConfiguration } from '../../context/configurationContext';
import css from './Footer.module.css';

const currentYear = new Date().getFullYear();
const InstagramIcon = instagramIconV2;

const linksMap = {
  home: 'LandingPage',
  reviews: 'ReviewsPage',
  resale: 'ResalePage',
  'shop now': 'ResalePage',
  'shop resale': 'ResalePage',
  'start selling': 'StartSellingSignupPage',
  about: 'AboutPage',
  'about us': 'AboutPage',
  'why us': 'TestimonialsPage',
  faq: 'FAQPage',
  // invite: 'InvitePage',
};

const isPrimary = o => o.group === 'primary';
const isSecondary = o => o.group === 'secondary';
const compareGroups = (a, b) => {
  const isAHigherGroupThanB = isPrimary(a) && isSecondary(b);
  const isALesserGroupThanB = isSecondary(a) && isPrimary(b);
  // Note: sort order is stable in JS
  return isAHigherGroupThanB ? -1 : isALesserGroupThanB ? 1 : 0;
};
// Returns links in order where primary links are returned first
const sortCustomLinks = customLinks => {
  const links = Array.isArray(customLinks) ? customLinks : [];
  return links.sort(compareGroups);
};

const Footer = () => {
  const config = useConfiguration();
  // Custom links are sorted so that group="primary" are always at the beginning of the list.
  const sortedCustomLinks = sortCustomLinks(config.topbar?.customLinks);

  return (
    <footer className={css.footer}>
      <div className={css.container}>
        {/* Logo */}
        <div className={css.logoWrapper}>
          <LinkedLogo
            rootClassName={css.logoLink}
            logoClassName={css.logo}
            logoImageClassName={css.logoImage}
            layout="desktop"
          />
        </div>

        <div className={css.socialIconMobile}>
          <ExternalLink
            href="https://www.instagram.com/unvarnished.clothing"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <InstagramIcon className={css.socialIconVector} />
          </ExternalLink>
        </div>

        {/* Social Media Icon */}
        <div className={css.socialIconDesktop}>
          <ExternalLink
            href="https://www.instagram.com/unvarnished.clothing"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <InstagramIcon className={css.socialIconVector} />
          </ExternalLink>
        </div>

        {/* Meta Information */}
        <div className={css.meta}>
          {/* Copyright */}
          <div className={css.copyright}>
            &copy; Unvarnished Clothing {currentYear}. All rights reserved.
          </div>

          {/* Footer Menu */}
          <nav className={css.footerMenu}>
            {sortedCustomLinks.map(link => (
              <NamedLink
                key={link.text}
                name={linksMap[link.text]}
                params={link.text === 'faq' ? { pageId: 'faq' } : undefined}
                className={css.menuLink}
              >
                {link.text}
              </NamedLink>
            ))}
          </nav>

          {/* Legal Links */}
          <div className={css.legalLinks}>
            <NamedLink name="TermsOfServicePage" className={css.legalLink}>
              Terms and conditions
            </NamedLink>
            <NamedLink name="PrivacyPolicyPage" className={css.legalLink}>
              Privacy policy
            </NamedLink>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
